import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './../../styles/user/galeria.css';
import * as globals from './../../components/GlobalScripts.js';

const User_dieta = () => {
    let path_api = localStorage.getItem('path_api');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [imagenes, setImagenes] = useState([]);

    const [uploadedImages, setUploadedImages] = useState([]);
    const [highlight, setHighlight] = useState(false);

    const [selectedImages, setSelectedImages] = useState([]);

    useEffect(() => {
        get_imagenes();
    }, [currentPage]);

    const get_imagenes = async () => {
        globals.validateSession();
        globals.openViewCharge();
        await axios.post(`${path_api}/user/galeria.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            page: currentPage,
            limit: 40
        }).then(response => {
            if (response.data.mensaje === "success") {
                setImagenes(response.data.imagenes);
                setTotalPages(response.data.total_pages);
            } else if (response.data.mensaje) {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje, effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: "No se obtuvieron las imágenes", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error 'log-imagenes-1'", msg: "Si persiste informa al soporte", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
        globals.closeViewCharge();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setHighlight(false);
        let files = Array.from(e.dataTransfer.files);
        handleFiles(files);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setHighlight(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setHighlight(false);
    };

    const handleFiles = (files) => {
        const validImages = files.filter(file => file.type.includes('image'));
        const totalAlready = uploadedImages.length;
        const totalNew = validImages.length;
        if (totalAlready + totalNew > 10) {
            globals.createAlert({ type: "advertencia", msg_title: "Límite superado", msg: "Solo puedes subir hasta 10 imágenes a la vez", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            return;
        }

        const newFiles = validImages.map(file => ({
            file,
            preview: URL.createObjectURL(file)
        }));
        setUploadedImages(prev => [...prev, ...newFiles]);
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        handleFiles(files);
    };

    const removePreviewImage = (index) => {
        setUploadedImages(prev => prev.filter((_, i) => i !== index));
    };

    const sendImagesToBackend = async () => {
        const formData = new FormData();
        uploadedImages.forEach((imgObj) => {
            formData.append('images[]', imgObj.file);
        });
        formData.append('rute', globals.getRuteBackend());
        formData.append('session_id', globals.get_session_id());
        formData.append('keylogin', globals.get_keylogin());

        globals.openViewCharge();
        await axios.post(`${path_api}/user/upload_imagenes.php`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
            if (response.data.mensaje === "success") {
                globals.createAlert({ type: "success", msg_title: "Éxito", msg: "Imágenes subidas correctamente", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
                localStorage.setItem('user', JSON.stringify(response.data.user));
                setUploadedImages([]);
                get_imagenes();
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje || "Error al subir imágenes", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Error al subir imágenes", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
        globals.closeViewCharge();
    };

    const handleSelectImage = (img_id) => {
        setSelectedImages(prev => prev.includes(img_id) ? prev.filter(id => id !== img_id) : [...prev, img_id]);
    };

    const deleteSelectedImages = async () => {
        if (selectedImages.length === 0) {
            globals.createAlert({ type: "advertencia", msg_title: "Info", msg: "No has seleccionado imágenes", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            return;
        }

        globals.openViewCharge();
        await axios.post(`${path_api}/user/delete_imagenes.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            images: selectedImages
        }).then(response => {
            if (response.data.mensaje === "success") {
                globals.createAlert({ type: "success", msg_title: "Éxito", msg: "Imágenes eliminadas correctamente", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
                localStorage.setItem('user', JSON.stringify(response.data.user));
                setSelectedImages([]);
                get_imagenes();
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje || "Error al eliminar imágenes", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Error al eliminar imágenes", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
        globals.closeViewCharge();
    };

    const changePage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const toggleSelectAll = () => {
        if (selectedImages.length === imagenes.length && imagenes.length > 0) {
            setSelectedImages([]);
        } else {
            setSelectedImages(imagenes.map(img => img.id));
        }
    };

    return (
        <div className="page-galeria container-section flex-column gap-20">
            <h2>Galería de Imágenes</h2>

            <div
                className={`dropzone ${highlight ? 'highlight' : ''}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={() => { document.getElementById('file-input').click(); }}
            >
                <p>Arrastra aquí tus imágenes o haz click aquí</p>
                <input type="file" multiple onChange={handleFileChange} style={{ display: 'none' }} id="file-input" />
            </div>

            {uploadedImages.length > 0 && (
                <div className="container-table preview-container">
                    <h3>Imágenes a subir:</h3>
                    <div className="preview-grid">
                        {uploadedImages.map((imgObj, index) => (
                            <div className="preview-item" key={index}>
                                <img src={imgObj.preview} alt="preview" />
                                <button onClick={() => removePreviewImage(index)}>X</button>
                            </div>
                        ))}
                    </div>
                    <div className='actions'>
                        <button onClick={sendImagesToBackend} className="btn-submit-images">Subir al servidor</button>
                    </div>
                </div>
            )}

            <div className="container-table stored-images-container">
                <div className="actions">
                    <input
                        type="checkbox"
                        checked={selectedImages.length === imagenes.length && imagenes.length > 0}
                        onChange={toggleSelectAll}
                    />
                    <label>Seleccionar todo</label>

                    {selectedImages.length > 0 && (
                        <button onClick={deleteSelectedImages} className="btn-delete-selected">Eliminar seleccionadas ({selectedImages.length})</button>
                    )}
                </div>

                {imagenes.length > 0 ? (
                    <div className="images-grid">
                        {imagenes.map(img => (
                            <div key={img.id} className="image-item">
                                <div className="image-select">
                                    <input
                                        type="checkbox"
                                        checked={selectedImages.includes(img.id)}
                                        onChange={() => handleSelectImage(img.id)}
                                    />
                                </div>
                                <div className="image-thumb">
                                    <img
                                        src={`${path_api}${img.url_imagen}`}
                                        alt={`img-${img.id}`}
                                        loading="lazy"
                                    />
                                </div>
                                <span>ID: {img.id}</span>
                                <span
                                    className='copy-link-image'
                                    onClick={() => globals.copyText(`${path_api}${img.url_imagen}`)}
                                >
                                    link
                                </span>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p>No hay imágenes almacenadas.</p>
                )}

                <div className="pagination">
                    <div>
                        <span>Mostrando <b>{imagenes.length}</b> imágenes</span>
                    </div>
                    <div>
                        <button onClick={() => changePage(currentPage - 1)} disabled={currentPage === 1}>
                            Anterior
                        </button>
                        <span>Página <b>{currentPage}</b> de <b>{totalPages}</b></span>
                        <button onClick={() => changePage(currentPage + 1)} disabled={currentPage === totalPages}>
                            Siguiente
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default User_dieta;
